// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2mCte","list":"BalanceDue_list__3J1N2","listRow":"BalanceDue_listRow__B3wPL","total":"BalanceDue_total__kWrtF"};